import { ActionMeta, SingleValue } from "react-select";
import { ISelectBoxType } from "../../../../../../types";
import { styles } from "./styles";

type Props = {
  options: Array<ISelectBoxType>;
  placeholderText: string;
  onChange: (value: ISelectBoxType) => void;
  selectTerm: ISelectBoxType | null;
  clearable: boolean;
};

export default function SelectDropdown({
  options,
  placeholderText,
  onChange,
  selectTerm,
  clearable,
}: Props) {
  function handleOnChange(
    newValue: SingleValue<ISelectBoxType>,
    _actionMeta: ActionMeta<ISelectBoxType>
  ) {
    onChange(newValue as ISelectBoxType);
  }

  return (
    <styles.SelectDropdown
      onChange={handleOnChange}
      value={selectTerm?.value ? selectTerm : null}
      options={options}
      placeholder={placeholderText}
      isClearable={clearable}
      classNamePrefix="react-select"
      theme={(theme: any) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: "#C8CAD2",
          primary: "black",
        },
      })}
    />
  );
}
